import { render, staticRenderFns } from "./chatItem.vue?vue&type=template&id=6e395ccf&scoped=true"
import script from "./chatItem.vue?vue&type=script&lang=js"
export * from "./chatItem.vue?vue&type=script&lang=js"
import style0 from "./chatItem.vue?vue&type=style&index=0&id=6e395ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e395ccf",
  null
  
)

export default component.exports